import _sortBy from 'lodash/sortBy';
/**
 * Sort function to order TransferToAgentItems first by status (including
 * disabled status), and then alphabetically
 *
 * @param transferToAgentItems The items to sort
 * @param disabledItems All disabled TransferToAgentItem ids
 * @returns TransferToAgentItem[] sorted array of TransferToAgentItems
 */
export function sortTransferToAgentItems(transferToAgentItems, disabledItems) {
    return _sortBy(transferToAgentItems, [
        function (element) {
            const rank = {
                working: 1,
                acw: 2,
                away: 3,
                offline: 4,
                unknown: 5,
            };
            if (disabledItems.includes(element.id)) {
                return 100;
            }
            return rank[element.status];
        },
        function (element) {
            var _a;
            return (_a = element.name) !== null && _a !== void 0 ? _a : '';
        },
    ]);
}
